import Vue from 'vue'

export default {
    setQuestionnaireData(state, {questionnaireData, questionnaireId}) {
        Vue.set(state.questionnaire, questionnaireId, questionnaireData)
    },
    startLoadingQuestionnaire(state, questionnaireId) {
        Vue.set(state.loading, questionnaireId, true)
    },
    finishLoadingQuestionnaire(state, questionnaireId) {
        Vue.set(state.loading, questionnaireId, false)
    },
    setPatientList(state, {user, questionId, key}) {
        if(questionId !== state.userListObj.questionId)
            state.userListObj = {
                questionId,
                keyUserList: [{
                    key,
                    user
                }]
            }
        else {
            const keyUserList = [
                ...state.userListObj.keyUserList,
                {
                    key,
                    user
                }
            ]
            state.userListObj = {
                questionId,
                keyUserList
            }
        }
    },
    removePatientList(state, key) {
        if(!key)
            state.userListObj = {
                keyUserList: [],
                questionId: '',
                userList: []
            }
        else {
            const keyIndex = state.userListObj.keyUserList.findIndex((keyUser) => keyUser.key === key)
            if(keyIndex > -1) {
                state.userListObj.keyUserList.splice(keyIndex, 1)
            }
        }
    }

}
